import React, { Component } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { StaticImage } from 'gatsby-plugin-image';

export default class ProjectSliderLemochlo extends Component {
  // componentDidMount() {}

  render() {
    const settings = {
      dots: false,
      // slidesToShow: 3,
      arrows: false,
      // centerMode: true,
      // speed: 3000,
      // autoplay: true,
      // centerPadding: '50px',
      speed: 5000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      responsive: [
        {
          breakpoint: 770,
          settings: {
            slidesToShow: 2,
            centerMode: true,
            centerPadding: '30px',
          },
        },
      ],
    };
    // $('.projectSlide').click(function(e) {
    //   $('.projectSlide').slick('slickNext');
    // });
    return (
      <div>
        <Slider {...settings}>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemochlo_1.jpg"
              alt="レモクロ"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemochlo_2.jpg"
              alt="レモクロ"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemochlo_3.jpg"
              alt="レモクロ"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemochlo_4.jpg"
              alt="レモクロ"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemochlo_5.jpg"
              alt="レモクロ"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemochlo_6.jpg"
              alt="レモクロ"
              placeholder="blurred"
            />
          </div>
          <div className="projectSlide">
            <StaticImage
              src="../../images/projects/lemochlo_7.jpg"
              alt="レモクロ"
              placeholder="blurred"
            />
          </div>
        </Slider>
      </div>
    );
  }
}
